import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  header: {
    borderTop: `1px solid ${theme.colorPalette.green_75_op_40}`,
    borderRadius: 0,
    minHeight: 'unset',
    height: 48
  },
  content: {
    padding: 0
  },
  buttonContainer: {
    top: 0,
    right: 0,
    height: 48,
    alignItems: 'center'
  },
  collapse: {
    minHeight: '40px !important',
    height: 'unset !important',
    marginBottom: 0,
    padding: 0
  },
  container: {
    minHeight: 'unset',
    boxShadow: 'none',
    backgroundColor: 'transparent'
  },
  containerOpen: {
    paddingBottom: theme.spacing(4)
  }
});

export default makeStyles(styles);
